// -----------------  AUTHORIZE LOGIN CODE -----------------
export const AUTHORIZE_LOGIN_CODE_LOADING = 'AUTHORIZE_LOGIN_CODE_LOADING';
export const AUTHORIZE_LOGIN_CODE_SUCCESS = 'AUTHORIZE_LOGIN_CODE_SUCCESS';
export const AUTHORIZE_LOGIN_CODE_ERROR = 'AUTHORIZE_LOGIN_CODE_ERROR';

// -----------------  CLEAR STATE -----------------
export const CLEAR_USER_LOGIN_CODE_STATE = 'CLEAR_USER_LOGIN_CODE_STATE';
